export default {
  defaultAvatar: 'https://discordapp.com/assets/1cbd08c76f8af6dddce02c5138971129.png',
  memberCardWidth: 250
};
